/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SyncRejectedDepositAttemptWithLitRequest} from '@cash-web/protos/squareup/cash/cryptosparky/api/deposits/public.pb'
import {SyncRejectedDepositAttemptWithLitResponse} from '@cash-web/protos/squareup/cash/cryptosparky/api/deposits/public.pb'


export const syncRejectedDepositAttemptWithLit = (request: SyncRejectedDepositAttemptWithLitRequest, options?: CashRequestOptions) => post<SyncRejectedDepositAttemptWithLitRequest, SyncRejectedDepositAttemptWithLitResponse>("/2.0/cash/sync-rejected-deposit-attempt-with-lit", request, {...options, rejectOnError: true })